/*
These functions make sure WordPress
and Foundation play nice together.
*/

jQuery(document).ready(function() {

    jQuery("a[href='#top']").click(function() {
        jQuery("html, body").animate({ scrollTop: 0 }, "slow");
        return false;
    });


    var McButton = jQuery("[data=hamburger-menu]");
    var McBar1 = McButton.find("b:nth-child(1)");
    var McBar2 = McButton.find("b:nth-child(2)");
    var McBar3 = McButton.find("b:nth-child(3)");

    var MenuBox = jQuery('#wrapper-main-nav #menu-main-menu');

    McButton.click( function() {
        jQuery(this).toggleClass("active");

        if (McButton.hasClass("active")) {
            McBar1.velocity({ top: "50%" }, {duration: 200, easing: "swing"});
            McBar3.velocity({ top: "50%" }, {duration: 200, easing: "swing"})
                .velocity({rotateZ:"90deg"}, {duration: 800, delay: 200, easing: [500,20] });
            McButton.velocity({rotateZ:"135deg"}, {duration: 800, delay: 200, easing: [500,20] });

            MenuBox.show();
        } else {
            McButton.velocity("reverse");
            McBar3.velocity({rotateZ:"0deg"}, {duration: 800, easing: [500,20] })
                .velocity({ top: "100%" }, {duration: 200, easing: "swing"});
            McBar1.velocity("reverse", {delay: 800});

            MenuBox.hide();
        }
    });

    var player = videojs('main-video');


    jQuery('#videoModal').on('open.zf.reveal', function(){
        player.play();
    });


    jQuery('#videoModal').on('closed.zf.reveal', function(){
        player.pause();
    });


    jQuery('a[href^="#"]').click(function () {
        jQuery('html, body').animate({
            scrollTop: jQuery('#' + jQuery.attr(this, 'href').substr(1) ).offset().top
        }, 500);
        return false;
    });


}); 